import { render, staticRenderFns } from "./bkItem.vue?vue&type=template&id=aeef02d2&scoped=true"
import script from "./bkItem.vue?vue&type=script&lang=js"
export * from "./bkItem.vue?vue&type=script&lang=js"
import style0 from "./bkItem.vue?vue&type=style&index=0&id=aeef02d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeef02d2",
  null
  
)

export default component.exports